@if (!(isSelectedPointEmpty$ | async) && (reportCount$ | async)! === 1) {
  <div
    class="button-container"
    >
    <button
      class="atlas-icon-button"
      mat-flat-button
      color="primary"
      aria-label="Download report"
      (click)="onFileDownloadClicked()"
      matTooltip="Download report"
      [matTooltipShowDelay]="1000"
      [matTooltipHideDelay]="1000"
      [disabled]="isReportInProgress$ | async"
      >
      @if (isReportInProgress$ | async) {
        <mat-spinner
          class="icon-button-spinner"
          diameter="24"
          strokeWidth="2"
          >
        </mat-spinner>
      }
      @if (!(isReportInProgress$ | async)) {
        <mat-icon>download</mat-icon>
      }
    </button>
  </div>
}

@if (!(isSelectedPointEmpty$ | async) && (reportCount$ | async)! !== 1) {
  <div
    class="button-container"
    >
    <button
      mat-flat-button
      color="primary"
      class="launch-button"
      (click)="onLaunchReporting()"
      [disabled]="(reportCount$ | async)! === 0 || (isReportInProgress$ | async)"
      >
      @if (isReportInProgress$ | async) {
        <mat-spinner
          class="icon-button-spinner"
          diameter="24"
          strokeWidth="2"
          >
        </mat-spinner>
      }
      @if (!(isReportInProgress$ | async)) {
        <span i18n="@@launchReportingButton"
          >Launch Reporting</span
          >
        }
      </button>
    </div>
  }
